import type { FaireProductEntity } from "../../entity_types/product";

export const p_gr9w4m6pmk: FaireProductEntity = {
  token: "p_gr9w4m6pmk",
  type: "product",
  name: "Sweet Wink Gold Top Hangers - 12 Pack - Children's Hanger",
  brandToken: "b_gro99lye",
  brandName: "Sweet Wink",
  imageUrl:
    "https://cdn.faire.com/fastly/5def6e2d850b81be777d2f2395be3e4aed4612a387c38927e9d98e96e12b0f68.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2c7a235d0536e0186436c2efd58742bee1d1fb9eb762ef605967470134393ea5.jpeg",
  ],
  priceDollars: 16,
  description:
    'These Sweet Wink Gold Top Hangers are the perfect way to hang our shirts, sweatshirts, dresses and capes. Paired with the Sweet Wink Bottom Hangers, you can be sure to have an elegant visual display.\n\n𝐅𝐞𝐚𝐭𝐮𝐫𝐞𝐬:\n• Color: Gold\n• Dimensions: 12.6" wide, 7.9" tall\n• Quantity: 12\n• Engraved with the Sweet Wink logo',
  tags: [],
  msrpDollars: 32,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T03:44:30.162Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
